import { callApi } from "@/api/api-core";

export const calculateRefund = function(
    accessToken,
    ownerHandlesFailure
) {
    return callApi(
            "GET",
            "v1/refunds/fullvoucher/calculate",
            undefined,
            accessToken,
            ownerHandlesFailure
        );
};

export const requestRefund = function(
    name,
    address,
    postalCode,
    city,
    country,
    cpr,
    dkRegistrationNumber,
    dkAccountNumber,
    swiftNumber,
    ibanNumber,
    accessToken,
    ownerHandlesFailure
) {
    const requestData = {
        name,
        address,
        postalCode,
        city,
        country,
        cpr,
        dkRegistrationNumber,
        dkAccountNumber,
        swiftNumber,
        ibanNumber
    };

    return callApi(
        "POST",
        "v1/refunds/fullvoucher/request",
        requestData,
        accessToken,
        ownerHandlesFailure
    );
};
